import http from '@/utils/axios/axios.js'

export const useAxios = (
  { url, method, params },
  { files = [], name = 'file', ...otherParams } = {}
) => {
  if (files.length === 0) {
    return http.request({
      method,
      url,
      params,
    })
  } else {
    return http.request({
      url,
      method,
      formData: files,
      name,
      ...otherParams,
    })
  }
}

export const useApi = async (
  { url, method = 'POST', params },
  { files = [], name = 'file', ...otherParams } = {}
) => {
  let requireURL = ''
  if (/^(https?:\/\/)/i.test(url)) {
    requireURL = url
    return {
      data: await useAxios(
        {
          url: requireURL,
          method,
          params,
        },
        {
          files,
          name,
          ...otherParams,
        }
      ),
    }
  } else {
    requireURL = url
    let data = await useAxios(
      {
        url: requireURL,
        method,
        params,
      },
      {
        files,
        name,
        ...otherParams,
      }
    )

    return {
      data,
    }
  }
}
